<!--<div id="error-messages" class="error-messages" *ngIf="errorCode && message">{{message}}</div>-->
<div id="error-messages" class="error-messages"
     *ngIf="createBubble"
     (click)="closeBubble();"
     [ngClass]="{'active' : showtime}">{{message}}</div>
